(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('product-shipping-simulator')) {
    return;
  }

  var utils = window.ElazProductShippingUtils;

  if (
    !utils ||
    typeof utils.normalizePostalCode !== 'function' ||
    typeof utils.consolidateSimulationItems !== 'function' ||
    typeof utils.snapshotCartItems !== 'function' ||
    typeof utils.cartItemsSignature !== 'function'
  ) {
    return;
  }

  var ERROR_DATA_KEYS = {
    invalid_zip: 'invalidZip',
    no_rates: 'noRates',
    selection_required: 'selectionRequired',
    cart_access_error: 'cartAccessError',
    lookup_error: 'lookupError',
    cart_changed: 'cartChanged',
    restore_error: 'restoreError',
  };
  var CART_LOCK_NAME = 'elaz-product-shipping-cart';
  var activeTransaction = null;
  var BRAZILIAN_PROVINCES = {
    AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia',
    CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás',
    MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais',
    PA: 'Pará', PB: 'Paraíba', PR: 'Paraná', PE: 'Pernambuco', PI: 'Piauí',
    RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul',
    RO: 'Rondônia', RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo',
    SE: 'Sergipe', TO: 'Tocantins',
  };

  function ShippingError(type) {
    this.name = 'ShippingError';
    this.type = type;
    this.message = type;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ShippingError);
    }
  }

  ShippingError.prototype = Object.create(Error.prototype);
  ShippingError.prototype.constructor = ShippingError;

  function typedError(type) {
    return new ShippingError(type);
  }

  function withCartLock(callback) {
    var locks = window.navigator && window.navigator.locks;

    if (!locks || typeof locks.request !== 'function') {
      return callback();
    }

    return locks.request(
      CART_LOCK_NAME,
      { mode: 'exclusive', ifAvailable: true },
      function (lock) {
        if (!lock) {
          throw typedError('cart_changed');
        }
        return callback();
      }
    );
  }

  function route(path) {
    var routes = window.routes || {};
    var rootUrl = typeof routes.root_url === 'string' && routes.root_url !== '' ? routes.root_url : '/';

    return rootUrl.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function cartAddUrl() {
    var routes = window.routes || {};
    return routes.cart_add_url || route('cart/add.js');
  }

  function shippingQuery(address) {
    return '?shipping_address%5Bzip%5D=' + encodeURIComponent(address.zip) +
      '&shipping_address%5Bcountry%5D=Brazil' +
      '&shipping_address%5Bprovince%5D=' + encodeURIComponent(address.province);
  }

  async function readJsonResponse(response) {
    if (!response || !response.ok) {
      throw new Error('request failed');
    }

    return response.json();
  }

  async function getJson(url) {
    var response = await window.fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });

    return readJsonResponse(response);
  }

  async function postJson(url, body) {
    var options = {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    };

    if (body !== undefined) {
      options.body = JSON.stringify(body);
    }

    var response = await window.fetch(url, options);
    return readJsonResponse(response);
  }

  function visitDeliveryValues(value, visitor) {
    if (Array.isArray(value)) {
      value.forEach(function (entry) {
        visitDeliveryValues(entry, visitor);
      });
      return;
    }

    if (value && typeof value === 'object') {
      Object.keys(value).forEach(function (key) {
        visitDeliveryValues(value[key], visitor);
      });
      return;
    }

    visitor(value);
  }

  function uniqueSorted(values) {
    return values.filter(function (value, index) {
      return values.indexOf(value) === index;
    }).sort(function (left, right) {
      return left - right;
    });
  }

  function deliveryDaysFromString(value) {
    var match = value.match(
      /^\s*(\d+)(?:\s*(?:-|–|—|to|a|até|ate|e|and|y|bis|à|tra)\s*(\d+))?\s*(?:business\s+days?|days?|d[ií]as?(?:\s+(?:útil|úteis|util|uteis|hábil|hábiles|habil|habiles))?|jours?(?:\s+ouvrés?)?|werktag(?:e|en)?|giorn[oi](?:\s+lavorativ[oi])?)?\s*$/i
    );

    if (!match) {
      return [];
    }

    var endpoints = [match[1], match[2]].filter(Boolean).map(Number);
    var valid = endpoints.every(function (day) {
      return Number.isInteger(day) && day > 0;
    });

    return valid ? endpoints : [];
  }

  function positiveDeliveryDays(value) {
    var days = [];

    visitDeliveryValues(value, function (entry) {
      if (typeof entry === 'number') {
        if (Number.isInteger(entry) && entry > 0) {
          days.push(entry);
        }
        return;
      }

      if (typeof entry !== 'string') {
        return;
      }

      deliveryDaysFromString(entry).forEach(function (day) {
        days.push(day);
      });
    });

    return uniqueSorted(days);
  }

  function isoDeliveryDates(value) {
    var dates = [];

    visitDeliveryValues(value, function (entry) {
      if (typeof entry !== 'string') {
        return;
      }

      var matches = entry.match(/\b\d{4}-\d{2}-\d{2}\b/g) || [];
      matches.forEach(function (match) {
        var parts = match.split('-').map(Number);
        var timestamp = Date.UTC(parts[0], parts[1] - 1, parts[2]);
        var parsed = new Date(timestamp);

        if (
          parsed.getUTCFullYear() === parts[0] &&
          parsed.getUTCMonth() === parts[1] - 1 &&
          parsed.getUTCDate() === parts[2]
        ) {
          dates.push(timestamp);
        }
      });
    });

    return uniqueSorted(dates);
  }

  function interpolate(template, replacements) {
    return Object.keys(replacements).reduce(function (message, key) {
      return message.replace(new RegExp('__' + key + '__', 'g'), String(replacements[key]));
    }, String(template || ''));
  }

  function formatDate(timestamp, locale) {
    var options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC',
    };

    try {
      return new Intl.DateTimeFormat(locale || 'pt-BR', options).format(new Date(timestamp));
    } catch (error) {
      return new Intl.DateTimeFormat('pt-BR', options).format(new Date(timestamp));
    }
  }

  function formatDeliveryDays(value, messages) {
    var days = positiveDeliveryDays(value);

    if (!days.length) {
      return '';
    }

    if (days.length === 1) {
      return interpolate(
        days[0] === 1 ? messages.deliveryDaysOne : messages.deliveryDaysOther,
        { count: days[0] }
      );
    }

    return interpolate(messages.deliveryDaysRange, {
      min: days[0],
      max: days[days.length - 1],
    });
  }

  function formatDeliveryDates(value, messages, locale) {
    var dates = isoDeliveryDates(value);

    if (!dates.length) {
      return '';
    }

    if (dates.length === 1) {
      return interpolate(messages.deliveryDate, { date: formatDate(dates[0], locale) });
    }

    return interpolate(messages.deliveryDateRange, {
      start: formatDate(dates[0], locale),
      end: formatDate(dates[dates.length - 1], locale),
    });
  }

  function formatDeliveryEstimate(rate, messages, locale) {
    var days = formatDeliveryDays(rate.delivery_days, messages);
    if (days) {
      return days;
    }

    var date = formatDeliveryDates(rate.delivery_date, messages, locale);
    if (date) {
      return date;
    }

    return formatDeliveryDates(rate.delivery_range, messages, locale);
  }

  function rateDetails(rate, messages) {
    var safeRate = rate || {};
    var service = safeRate.service_name || safeRate.presentment_name || safeRate.service || '';
    var name = safeRate.name || '';
    var title = service && name && service !== name ? service + ' — ' + name : service || name;
    var shopifyCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    var currency = safeRate.currency || shopifyCurrency || 'BRL';
    var numericPrice = Number(safeRate.price);
    var price = '';

    if (Number.isFinite(numericPrice)) {
      try {
        price = new Intl.NumberFormat(
          document.documentElement && document.documentElement.lang || 'pt-BR',
          { style: 'currency', currency: currency }
        ).format(numericPrice);
      } catch (error) {
        price = String(safeRate.price) + ' ' + currency;
      }
    }

    return {
      name: title,
      price: price,
      estimate: formatDeliveryEstimate(
        safeRate,
        messages || {},
        document.documentElement && document.documentElement.lang || 'pt-BR'
      ),
    };
  }

  function ProductShippingSimulator() {
    var element = Reflect.construct(HTMLElement, [], ProductShippingSimulator);
    element.activePromise = null;
    return element;
  }

  ProductShippingSimulator.prototype = Object.create(HTMLElement.prototype);
  ProductShippingSimulator.prototype.constructor = ProductShippingSimulator;

  ProductShippingSimulator.prototype.connectedCallback = function () {
    if (this.initialized) {
      return;
    }

    this.initialized = true;
    this.input = this.querySelector('[data-shipping-postal-code]');
    this.button = this.querySelector('[data-shipping-calculate]');
    this.status = this.querySelector('[data-shipping-status]');
    this.rates = this.querySelector('[data-shipping-rates]');
    this.activePromise = null;
    this.setLoading(false);
    this.hideOutput();
    this.bindEvents();
  };

  ProductShippingSimulator.prototype.bindEvents = function () {
    var simulator = this;

    if (this.button) {
      this.button.addEventListener('click', function () {
        simulator.calculate();
      });
    }

    if (this.input) {
      this.input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          simulator.calculate();
        }
      });
    }
  };

  ProductShippingSimulator.prototype.readSimulationItems = function () {
    if (this.dataset.shippingMode === 'combo') {
      var builder = this.closest('combo-builder');
      if (!builder || typeof builder.getShippingSimulationItems !== 'function') {
        return [];
      }

      return utils.consolidateSimulationItems(builder.getShippingSimulationItems());
    }

    var productInfo = this.closest('product-info');
    if (!productInfo) {
      return [];
    }

    var variantInput = productInfo.querySelector('input[data-product-form-variant]');
    if (!variantInput || String(variantInput.value || '').trim() === '') {
      return [];
    }

    var productForm = typeof variantInput.closest === 'function' ? variantInput.closest('form') : null;
    var availabilityContext = productForm || productInfo;
    var addButton = availabilityContext.querySelector(
      'button[type="submit"][name="add"], button[name="add"]'
    );
    if (
      addButton &&
      (addButton.disabled || addButton.getAttribute('aria-disabled') === 'true')
    ) {
      return [];
    }

    var quantityInput = productInfo.querySelector('[data-quantity-input]');
    var quantity = quantityInput ? Number(quantityInput.value) : 1;
    if (!Number.isInteger(quantity) || quantity <= 0) {
      quantity = 1;
    }

    return utils.consolidateSimulationItems([{ id: variantInput.value, quantity: quantity }]);
  };

  ProductShippingSimulator.prototype.calculate = function () {
    if (this.activePromise) {
      return this.activePromise;
    }

    var simulator = this;
    var postalCode = utils.normalizePostalCode(this.input && this.input.value);
    if (!postalCode) {
      this.hideOutput();
      this.renderError('invalid_zip');
      return Promise.resolve();
    }

    var items = this.readSimulationItems();
    if (!items.length) {
      this.hideOutput();
      this.renderError('selection_required');
      return Promise.resolve();
    }

    if (activeTransaction) {
      this.hideOutput();
      this.renderError('cart_changed');
      return Promise.resolve();
    }

    var calculation = (async function () {
      simulator.setLoading(true);
      simulator.hideOutput();
      simulator.renderCalculating();

      try {
        var rates = await withCartLock(function () {
          return simulator.runTransaction(postalCode, items);
        });
        simulator.renderRates(rates);
      } catch (error) {
        simulator.renderError(error && error.type ? error.type : 'lookup_error');
      } finally {
        simulator.setLoading(false);
      }
    }());

    this.activePromise = calculation;
    activeTransaction = calculation;
    calculation.then(function () {
      if (simulator.activePromise === calculation) {
        simulator.activePromise = null;
      }
      if (activeTransaction === calculation) {
        activeTransaction = null;
      }
    }, function () {
      if (simulator.activePromise === calculation) {
        simulator.activePromise = null;
      }
      if (activeTransaction === calculation) {
        activeTransaction = null;
      }
    });

    return calculation;
  };

  ProductShippingSimulator.prototype.setLoading = function (loading) {
    if (this.input) {
      this.input.disabled = loading;
      this.input.toggleAttribute('disabled', loading);
    }
    if (this.button) {
      this.button.disabled = loading;
      this.button.toggleAttribute('disabled', loading);
      this.button.classList.toggle('loading', loading);
    }
    this.setAttribute('aria-busy', loading ? 'true' : 'false');
  };

  ProductShippingSimulator.prototype.hideOutput = function () {
    if (this.status) {
      this.status.hidden = true;
      this.status.textContent = '';
      this.status.removeAttribute('data-shipping-state');
      this.status.classList.toggle('visually-hidden', false);
    }
    if (this.rates) {
      this.rates.hidden = true;
      this.rates.replaceChildren();
    }
  };

  ProductShippingSimulator.prototype.renderStatus = function (message, state, visuallyHidden) {
    if (!this.status) return;
    this.status.textContent = message || '';
    this.status.setAttribute('data-shipping-state', state);
    this.status.classList.toggle('visually-hidden', Boolean(visuallyHidden));
    this.status.hidden = false;
  };

  ProductShippingSimulator.prototype.renderError = function (type) {
    var key = ERROR_DATA_KEYS[type] || ERROR_DATA_KEYS.lookup_error;

    if (this.rates) {
      this.rates.hidden = true;
      this.rates.replaceChildren();
    }
    this.renderStatus(this.dataset[key] || '', type, false);
  };

  ProductShippingSimulator.prototype.renderCalculating = function () {
    this.renderStatus(this.dataset.calculating || '', 'calculating', true);
  };

  ProductShippingSimulator.prototype.renderRates = function (rates) {
    var simulator = this;
    var safeRates = Array.isArray(rates) ? rates : [];

    if (!safeRates.length) {
      this.renderError('no_rates');
      return;
    }

    this.hideOutput();
    safeRates.forEach(function (rate) {
      var item = document.createElement('li');
      var heading = document.createElement('div');
      var name = document.createElement('span');
      var price = document.createElement('strong');
      var details = rateDetails(rate, simulator.dataset);

      item.className = 'product-shipping-simulator__rate';
      heading.className = 'product-shipping-simulator__rate-heading';
      name.className = 'product-shipping-simulator__rate-name';
      price.className = 'product-shipping-simulator__rate-price';
      name.textContent = details.name;
      price.textContent = details.price;
      heading.appendChild(name);
      heading.appendChild(price);
      item.appendChild(heading);

      if (details.estimate) {
        var estimate = document.createElement('div');
        estimate.className = 'product-shipping-simulator__rate-estimate';
        estimate.textContent = details.estimate;
        item.appendChild(estimate);
      }

      simulator.rates.appendChild(item);
    });
    this.rates.hidden = false;
    var announcement = safeRates.length === 1
      ? this.dataset.ratesAvailableOne
      : this.dataset.ratesAvailableOther;
    var message = String(announcement || '')
      .replace(/__count__/g, String(safeRates.length));
    this.renderStatus(message, 'rates_available', true);
  };

  ProductShippingSimulator.prototype.getCart = async function () {
    var cart = await getJson(route('cart.js'));

    if (!cart || !Array.isArray(cart.items)) {
      throw new Error('invalid cart response');
    }

    return cart;
  };

  ProductShippingSimulator.prototype.clearCart = function () {
    return postJson(route('cart/clear.js'));
  };

  ProductShippingSimulator.prototype.addItems = function (items) {
    return postJson(cartAddUrl(), { items: items });
  };

  ProductShippingSimulator.prototype.lookupPostalCode = async function (postalCode) {
    var formattedPostalCode = postalCode.slice(0, 5) + '-' + postalCode.slice(5);
    try {
      var response = await window.fetch('https://viacep.com.br/ws/' + formattedPostalCode + '/json', {
        method: 'GET',
        headers: { Accept: 'application/json' },
      });
      var address = await readJsonResponse(response);
      var uf = address && String(address.uf || '').trim().toUpperCase();

      if (!address || address.erro || !uf || !BRAZILIAN_PROVINCES[uf]) {
        throw new Error('invalid postal code response');
      }

      var providedProvince = String(address.estado || '').trim();
      var province = providedProvince || BRAZILIAN_PROVINCES[uf];
      if (!province) {
        throw new Error('missing province');
      }

      return { zip: formattedPostalCode, province: province };
    } catch (error) {
      throw error && error.type === 'lookup_error' ? error : typedError('lookup_error');
    }
  };

  ProductShippingSimulator.prototype.fetchRates = async function (postalCode) {
    try {
      var address = await this.lookupPostalCode(postalCode);
      var response = await window.fetch(route('cart/shipping_rates.json') + shippingQuery(address), {
        method: 'GET',
        headers: { Accept: 'application/json' },
      });
      var ratesResponse = await readJsonResponse(response);
      if (!ratesResponse || !Array.isArray(ratesResponse.shipping_rates)) {
        throw new Error('invalid shipping rates response');
      }
      return ratesResponse.shipping_rates;
    } catch (error) {
      throw error && error.type === 'lookup_error' ? error : typedError('lookup_error');
    }
  };

  ProductShippingSimulator.prototype.runTransaction = async function (postalCode, simulationItems) {
    var originalCart;
    var originalItems;
    var originalSignature;
    var expectedTemporarySignature = utils.cartItemsSignature(simulationItems);

    try {
      originalCart = await this.getCart();
      originalItems = utils.snapshotCartItems(originalCart);
      originalSignature = utils.cartItemsSignature(originalItems);

      var preflightCart = await this.getCart();
      if (utils.cartItemsSignature(preflightCart) !== originalSignature) {
        throw typedError('cart_changed');
      }
    } catch (error) {
      if (error && error.type === 'cart_changed') {
        throw error;
      }
      throw typedError('cart_access_error');
    }

    var mutationAttempted = false;
    var temporarySignature = null;
    var setupStage = 'before_clear';
    var operationError = null;
    var rates = null;

    try {
      mutationAttempted = true;
      setupStage = 'clear_started';
      await this.clearCart();
      setupStage = 'clear_confirmed';
      await this.beforeSimulationAdd();
      setupStage = 'add_started';
      await this.addItems(simulationItems);
      setupStage = 'add_confirmed';

      var temporaryCart = await this.getCart();
      if (utils.cartItemsSignature(temporaryCart) !== expectedTemporarySignature) {
        throw typedError('cart_changed');
      }
      temporarySignature = expectedTemporarySignature;
      setupStage = 'temporary_confirmed';

      try {
        rates = await this.fetchRates(postalCode);
      } catch (error) {
        operationError = typedError('lookup_error');
      }
    } catch (error) {
      operationError = error && error.type ? error : typedError('cart_access_error');
    }

    if (operationError && operationError.type === 'cart_changed') {
      throw operationError;
    }

    if (mutationAttempted) {
      await this.restoreCart(
        originalItems,
        originalSignature,
        expectedTemporarySignature,
        temporarySignature,
        setupStage
      );
    }

    if (operationError) {
      throw operationError;
    }

    return rates;
  };

  ProductShippingSimulator.prototype.restoreCart = async function (
    originalItems,
    originalSignature,
    expectedTemporarySignature,
    temporarySignature,
    setupStage
  ) {
    var liveCart = null;

    for (var readAttempt = 0; readAttempt < 2; readAttempt += 1) {
      try {
        liveCart = await this.getCart();
        break;
      } catch (error) {
        if (readAttempt === 1) {
          throw typedError('restore_error');
        }
      }
    }

    var liveSignature = utils.cartItemsSignature(liveCart);
    var ownedPreRestoreSignature = null;
    if (temporarySignature !== null) {
      if (liveSignature !== temporarySignature) {
        throw typedError('cart_changed');
      }
      ownedPreRestoreSignature = temporarySignature;
    } else {
      if (liveSignature === originalSignature) {
        this.notifyRestored(liveCart);
        return;
      }

      if (
        setupStage === 'clear_confirmed' &&
        liveSignature === utils.cartItemsSignature([])
      ) {
        ownedPreRestoreSignature = liveSignature;
      } else if (
        (setupStage === 'add_started' || setupStage === 'add_confirmed') &&
        liveSignature === expectedTemporarySignature
      ) {
        ownedPreRestoreSignature = expectedTemporarySignature;
      } else {
        throw typedError('cart_changed');
      }
    }

    for (var attempt = 0; attempt < 2; attempt += 1) {
      var stage = 'before_clear';

      try {
        await this.clearCart();
        stage = 'clear_confirmed';
      } catch (error) {
        if (attempt === 1) {
          throw typedError('restore_error');
        }

        var clearProbe;
        try {
          clearProbe = await this.getCart();
        } catch (probeError) {
          throw typedError('restore_error');
        }

        var clearProbeSignature = utils.cartItemsSignature(clearProbe);
        if (clearProbeSignature === originalSignature) {
          this.notifyRestored(clearProbe);
          return;
        }
        if (
          ownedPreRestoreSignature !== null &&
          clearProbeSignature === ownedPreRestoreSignature
        ) {
          continue;
        }
        throw typedError('cart_changed');
      }

      if (stage !== 'clear_confirmed') {
        throw typedError('restore_error');
      }

      if (originalItems.length) {
        stage = 'add_started';
        try {
          await this.addItems(originalItems);
          stage = 'add_confirmed';
        } catch (error) {
          var addProbe;
          try {
            addProbe = await this.getCart();
          } catch (probeError) {
            throw typedError('restore_error');
          }

          if (utils.cartItemsSignature(addProbe) === originalSignature) {
            this.notifyRestored(addProbe);
            return;
          }
          throw typedError(stage === 'add_started' ? 'cart_changed' : 'restore_error');
        }
      }

      var verifiedCart;
      try {
        verifiedCart = await this.getCart();
      } catch (error) {
        try {
          verifiedCart = await this.getCart();
        } catch (probeError) {
          throw typedError('restore_error');
        }
      }

      if (utils.cartItemsSignature(verifiedCart) === originalSignature) {
        this.notifyRestored(verifiedCart);
        return;
      }
      throw typedError('cart_changed');
    }

    throw typedError('restore_error');
  };

  ProductShippingSimulator.prototype.beforeSimulationAdd = function () {};

  ProductShippingSimulator.prototype.notifyRestored = function (restoredCart) {
    this.dispatchEvent(new CustomEvent('product-shipping:cart-restored', {
      bubbles: true,
      detail: { cart: restoredCart },
    }));
  };

  window.customElements.define('product-shipping-simulator', ProductShippingSimulator);
}());
